import { isNumber } from "lodash";

import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (item: Order.Model, dateFns: DateFns): string => {
	if (!item?.id) return "";

	let waitingTimeMilliseconds = 0;
	let waitingClient = 0;

	if (isNumber(item?.additionalFields?.waitingTimeMilliseconds)) {
		waitingTimeMilliseconds = item.additionalFields.waitingTimeMilliseconds;
	}
	if (isNumber(item?.downtimes?.waitingClient)) {
		waitingClient = item.downtimes.waitingClient;
	}

	const value = Math.max(waitingClient + waitingTimeMilliseconds, 0);

	return dateFns.formatTime2(value, "HH:mm:ss", { timezone: "UTC" });
};

export default cellProcessing;
